// in src/users.js
import React from 'react';
import {ArrayField, ChipField, Datagrid, EditButton, List, ReferenceField, SingleFieldList, TextField, Pagination} from 'react-admin';
import {HASHTAG_CATEGORY, HASHTAG_CATEGORY_LIST, HASHTAG_MULTIPLE_LIST, HASH_TAG} from '../../consts/Names';

export const HashTagsForCategoryList = (props) => {
   return (
      <List {...props} title="List for categories" bulkActionButtons={false} exporter={false}  perPage={25} pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}>
         <Datagrid rowClick="show">
            <TextField source={HASHTAG_MULTIPLE_LIST.id} sortable={false} />
            <ReferenceField source={HASHTAG_CATEGORY_LIST.category_id} reference={HASHTAG_CATEGORY.SOURCE} sortable={false}>
               <TextField source={HASHTAG_CATEGORY.name} />
            </ReferenceField>
            <ArrayField label="Related tags" source={'tags'} sortable={false}>
               <SingleFieldList linkType={false}>
                  <ChipField source={HASH_TAG.name} />
               </SingleFieldList>
            </ArrayField>
            <EditButton />
         </Datagrid>
      </List>
   );
};
